export * from './remove-tags-from-order-panel/remove-tags-from-order-panel.component';
export * from './remove-tags-from-order.service';
